import { type ClientHint, getHintUtils } from '@epic-web/client-hints';
import { clientHint as colorSchemeHint } from '@epic-web/client-hints/color-scheme';
import { clientHint as timeZoneHint } from '@epic-web/client-hints/time-zone';

import { DEFAULT_LOCALE } from './format.ts';

const localeHint = {
	cookieName: 'CH-locale-v3',
	fallback: DEFAULT_LOCALE,
	getValueCode: 'navigator.language',
} as const satisfies ClientHint<string>;

const widthHint = {
	cookieName: 'CH-width',
	fallback: 1080,
	getValueCode: 'document.documentElement.clientWidth',
} as const satisfies ClientHint<number>;

const hintsUtils = getHintUtils({
	locale: localeHint,
	theme: colorSchemeHint,
	timeZone: timeZoneHint,
	width: widthHint,
});

export const { getHints } = hintsUtils;

export function getClientHintCheckScript(): string {
	return hintsUtils.getClientHintCheckScript();
}
